import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule, MatCardModule, MatCheckboxModule, MatExpansionModule, MatIconModule, MatMenuModule, MatSidenavModule, MatSnackBarModule, MatToolbarModule } from "@angular/material";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MarkdownModule } from "angular2-markdown";
import { CarouselModule } from "ngx-bootstrap";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ApplicationTypesModule } from "./components/application-types/application-types.module";
import { ContactCardComponent } from "./components/contact-card/contact-card.component";
import { FooterHomeComponent } from "./components/footer-home/footer-home.component";
import { HomeModule } from "./components/home/home.module";
import { NavBarComponent } from "./components/nav-bar/nav-bar.component";
import { OrganizationComponent } from "./components/organization/organization.component";
import { OrganizationCardComponent } from "./components/organizations/organization-card.component/organization-card.component";
import { OrganizationsComponent } from "./components/organizations/organizations.component";
import { TechnologiesComponent } from "./components/technologies/technologies.component";
import { TechnologyCardComponent } from "./components/technologies/technology-card.component/technology-card.component";
import { TechnologyModule } from "./components/technology/technology.module";
import { ApplicationTypeService } from "./services/ApplicationTypeService";
import { ImageService } from "./services/ImageService";
import { OrganizationService } from "./services/OrganizationService";
import { TechnologyCategoryService } from "./services/TechnologyCategoryService";
import { TechnologyService } from "./services/TechnologyService";

@NgModule({
	bootstrap: [
		AppComponent,
	],
	declarations: [
		AppComponent,
		FooterHomeComponent,
		NavBarComponent,
		ContactCardComponent,
		OrganizationsComponent,
		OrganizationComponent,
		OrganizationCardComponent,
		TechnologiesComponent,
		TechnologyCardComponent,
	],
	imports: [
		ApplicationTypesModule,
		AppRoutingModule,
		BrowserModule,
		BrowserAnimationsModule,
		HomeModule,
		HttpClientModule,
		MatButtonModule,
		MarkdownModule.forRoot(),
		MatCardModule,
		MatIconModule,
		MatMenuModule,
		MatToolbarModule,
		CarouselModule.forRoot(),
		TechnologyModule,
		AppRoutingModule,
		BrowserModule,
		FormsModule,
		MatSnackBarModule,
		HttpClientModule,
		MatCardModule,
		MatCheckboxModule,
		MatExpansionModule,
		MatSidenavModule,
		TechnologyModule,
	],
	providers: [
		ApplicationTypeService,
		ImageService,
		OrganizationService,
		TechnologyService,
		TechnologyCategoryService,
	],
} as NgModule)
export class AppModule implements NgModule { }



// WEBPACK FOOTER //
// ./Frontend/src/app/app.module.ts